import React from "react";

const WelcomeSettingsNotice: React.FC = () => {
  return (
    <div className="w-full max-w-5xl mx-auto bg-white border border-gray-200 rounded-2xl shadow-sm p-8 mt-10">
      <h2 className="text-3xl font-bold text-gray-800 mb-4">Welcome to Settings</h2>
      <p className="text-lg text-gray-600 mb-4">
        We're glad you're here! You can customize your experience using the{" "}
        <span className="text-blue-600 font-medium">More Settings</span> menu.
      </p>

      <div className="bg-blue-50 border border-blue-100 rounded-xl p-5 mb-6">
        <p className="text-blue-700 font-medium">
          Don’t miss the <span className="underline">Translate Settings</span> section — perfect for multilingual support.
        </p>
      </div>

      <p className="text-sm text-gray-500">
        We’re constantly improving — expect more setting options to appear here soon!
      </p>
    </div>
  );
};

export default WelcomeSettingsNotice;
